export const dataLibNum = [{
  word: 'yonn',
  partOfSpeech: 'PRO',
  definition: [1, '(one)'],
  egSentenceKw: 'Mi koko-a! Ès ou vlé yonn?',
  egSentenceEn: 'Look at the coconuts! Do you want one?',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dé',
  partOfSpeech: 'ADJ',
  definition: [2, '(two)'],
  egSentenceKw: 'Kay sala ni dé lapòt.',
  egSentenceEn: 'That house has two doors.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. deux]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'twa',
  partOfSpeech: 'ADJ',
  definition: [3, '(three)'],
  egSentenceKw: 'Yo ni twa ti manmay tousèl.',
  egSentenceEn: 'They have only three children.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. trois]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'senk',
  partOfSpeech: 'ADJ',
  definition: [5, '(five)'],
  egSentenceKw: 'Gason-an ni senk sésé.',
  egSentenceEn: 'The boy has five sisters.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. cinq]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sis',
  partOfSpeech: 'ADJ',
  definition: [6, '(six)'],
  egSentenceKw: 'Gason-an ni sis lanné.',
  egSentenceEn: 'The boy is six years old.',
  synonym: [null],
  antonym: [null],
  etymology: '[<  Fr. six]',
  dialect: '🇱🇨',
  variant: ['si'],
}, {
  word: 'ywit',
  partOfSpeech: 'ADJ',
  definition: [8, '(eight)'],
  egSentenceKw: 'Mwen ni ywit dòla tousèl.',
  egSentenceEn: 'I have only eight dollars.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. huit]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'nèf',
  partOfSpeech: 'ADJ',
  definition: [9, '(nine)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. neuf]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dis',
  partOfSpeech: 'ADJ',
  definition: [10, '(ten)'],
  egSentenceKw: 'Yo ni dis panyen mango.',
  egSentenceEn: 'They have ten baskets of mangoes.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dix]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sèt',
  partOfSpeech: 'ADJ',
  definition: [7, '(seven)'],
  egSentenceKw: 'Yo ni sèt mal bouwik.',
  egSentenceEn: 'They have seven male donkeys.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. sept]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kat',
  partOfSpeech: 'ADJ',
  definition: [4, '(four)'],
  egSentenceKw: 'Mwen vlé kat liv sèl.',
  egSentenceEn: 'I want four pounds of salt',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. quatre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wonz',
  partOfSpeech: 'ADJ',
  definition: [11, '(eleven)'],
  egSentenceKw: 'Ti manmay-la ni wonz lanné.',
  egSentenceEn: 'The child is eleven years old.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. onze]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'douz',
  partOfSpeech: 'ADJ',
  definition: [12, '(twelve)'],
  egSentenceKw: 'Mwen genyen douz zé.',
  egSentenceEn: 'I bought twelve eggs.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. douze]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'twèz',
  partOfSpeech: 'ADJ',
  definition: [13, '(thirteen)'],
  egSentenceKw: 'Nou ni twèz dòla tousèl.',
  egSentenceEn: 'We have only thirteen dollars.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. treize]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'katòz',
  partOfSpeech: 'ADJ',
  definition: [14, '(fourteen)'],
  egSentenceKw: 'Nou ni katòz liv.',
  egSentenceEn: 'We have fourteen books.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. quatorze]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kenz',
  partOfSpeech: 'ADJ',
  definition: [15, '(fifteen)'],
  egSentenceKw: 'Yo ni kenz dòla.',
  egSentenceEn: 'They have fifteen dollars.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. quinze]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sèz',
  partOfSpeech: 'ADJ',
  definition: [16, '(sixteen)'],
  egSentenceKw: 'I péyé sèz dòla pou dé koutla.',
  egSentenceEn: 'He paid sixteen dollars for two cutlasses.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. seize]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'disèt',
  partOfSpeech: 'ADJ',
  definition: [17, '(seventeen)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dix-sept]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dizwit',
  partOfSpeech: 'ADJ',
  definition: [18, '(eighteen)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dix-huit]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'diznèf',
  partOfSpeech: 'ADJ',
  definition: [19, '(nineteen)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dix-neuf]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ven',
  partOfSpeech: 'ADJ',
  definition: [20, '(twenty)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. vingt]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'twant',
  partOfSpeech: 'ADJ',
  definition: [30, '(thirty)'],
  egSentenceKw: 'I péyé nou twant dòla pou panyen mango-a.',
  egSentenceEn: 'He paid us thirty dollars for the basket of mangoes.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. trente]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'kawant',
  partOfSpeech: 'ADJ',
  definition: [40, '(forty)'],
  egSentenceKw: 'Yo ni kawant dòla.',
  egSentenceEn: 'They have forty dollars.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. quarante]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'senkant',
  partOfSpeech: 'ADJ',
  definition: [50, '(fifty)'],
  egSentenceKw: 'Si nou té ni senkant dòla nou té kay genyen\'y.',
  egSentenceEn: 'If we had fifty dollars we would buy it.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. cinquante]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'swasant',
  partOfSpeech: 'ADJ',
  definition: [60, '(sixty)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. soixante]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'swasant dis',
  partOfSpeech: 'ADJ',
  definition: [70, '(seventy)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. soixante-dix]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'katwiven',
  partOfSpeech: 'ADJ',
  definition: [80, '(eighty)'],
  egSentenceKw: 'Yo ni katwiven dòla.',
  egSentenceEn: 'They have eighty dollars.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. quatre-vingts]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'katwiven dis',
  partOfSpeech: 'ADJ',
  definition: [90, '(ninety)'],
  egSentenceKw: 'Yo ni katwiven dis dòla.',
  egSentenceEn: 'They have ninety dollars.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. quatre-vingt-deux]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'san',
  partOfSpeech: 'ADJ',
  definition: [100, '(hundred)'],
  egSentenceKw: 'Sa kouté konmen san dòla.',
  egSentenceEn: 'That costs many hundred dollars.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. cent]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'mil',
  partOfSpeech: 'ADJ',
  definition: [1000, '(thousand)'],
  egSentenceKw: 'I té ni senk mil dòla épi i pèd li.',
  egSentenceEn: 'He had five thousand dollars and he lost it.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. mille]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'pwèmyé',
  partOfSpeech: 'ADJ',
  definition: 'first',
  egSentenceKw: 'Ou ki pwèmyé moun mwen wè jòdi-a.',
  egSentenceEn: 'You are the first person I have seen today.',
  synonym: [null],
  antonym: ['dènyé', 'dènyé'],
  etymology: '[< Fr. premier]',
  dialect: '🇱🇨',
  variant: ['pwenmyé'],
}, {
  word: 'dézyenm',
  partOfSpeech: 'ADJ',
  definition: 'second',
  egSentenceKw: 'Nou ka fè dézyenm lison.',
  egSentenceEn: 'We\'re doing the second lesson.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. deuxième]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'twazyenm',
  partOfSpeech: 'ADJ',
  definition: 'third',
  egSentenceKw: 'I ka wété adan twazyenm kay-la.',
  egSentenceEn: 'He lives in the third house.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. troisième]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'katyenm',
  partOfSpeech: 'ADJ',
  definition: 'fourth',
  egSentenceKw: 'Sa sé katyenm fwa-a mwen ka alé lòt péyi.',
  egSentenceEn: 'This is the fourth time I\'m going overseas.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. quatrième]',
  dialect: '🇱🇨',
  variant: ['katzyenm'],
}, {
  word: 'senkyenm',
  partOfSpeech: 'ADJ',
  definition: 'fifth',
  egSentenceKw: 'Yo viwé asou senkyenm jou-a.',
  egSentenceEn: 'They returned on the fifth day.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. cinquième]',
  dialect: '🇱🇨',
  variant: [null],
},
];
